import React from "react";
import { useLang } from "../store";
import { useT } from "../i18n";

export default function PromoBanner() {
  const { lang } = useLang();
  const t = useT(lang);
  return (
    <div className="bg-[#FF3D7F] text-white border-b-[3px] border-[#0C0A09]" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-2.5 text-center">
        <span className="font-bold uppercase tracking-[0.18em] text-xs md:text-sm">
          {t.promo.banner}
        </span>
      </div>
    </div>
  );
}
